import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Vue2Filters from 'vue2-filters';
import Axios from 'axios';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import App from './App.vue';

// Fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import NProgress from 'nprogress';
library.add(faCoffee);

import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import '../node_modules/nprogress/nprogress.css';

import store from './store';
import router from './router';

import VueLocalStorage from 'vue-localstorage';
 
Vue.use(VueLocalStorage, {
  bind: true //created computed members from your variable declarations
});
Vue.use(VueFormWizard);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(BootstrapVue);
Vue.use(Vue2Filters);

Vue.prototype.$http = Axios;
const user = Vue.localStorage.get('user');
if (user && user.access && user.access.key) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = user.access.key;
}
Vue.prototype.$http.defaults.headers.common['Content-Type'] = 'application/json';
Vue.prototype.$http.defaults.headers.common['Accept'] = 'application/json';
Vue.prototype.$http.defaults.headers.common['Content-Encoding'] = 'identity';

const optionsNProgress = {
  latencyThreshold: 200, // Number of ms before progressbar starts showing, default: 100,
  router: true, // Show progressbar when navigating routes, default: true
  http: false // Show progressbar when doing Vue.http, default: true
};
Vue.use(NProgress, optionsNProgress);

Vue.config.productionTip = false;

new Vue({
  render (h) { return h(App) },
  router,
  store,
  localStorage
}).$mount('#app');
